import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchPurchaseReturnGSTR2 = createAsyncThunk(
  "purchaseReturnGSTR2/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/get-gstr2-summary", filters);
console.log(res, "API RESPONSE");
      // ✅ Correct extraction
      return res?.data || [];

    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "API Error"
      );
    }
  }
);